import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppSupportInbox.';
  public static readonly supportTicketsTitle = `${Id.prefix}supportTicketsTitle`;
}

export class LangAppSupportInbox {
  private constructor() {}
  public static supportTicketsTitle(): string {
    return interpolate(Id.supportTicketsTitle);
  }
}

export class AppSupportInboxModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.supportTicketsTitle, 'Support Tickets', 'Title for the support inbox page');
  }
}
